import script from "./CoachingCardInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./CoachingCardInfo.vue?vue&type=script&setup=true&lang=js"

import "./CoachingCardInfo.vue?vue&type=style&index=0&id=fc7de864&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc7de864"]])

export default __exports__